import { useNavigate } from 'react-router';
import { useGrowersDashboard } from '/@/hooks/dashboards';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';
import DashboardCard from '../../../../../components/bayer/dashboard-card';

const RVsDashboardCard = ({ userNodeId }: { userNodeId: number }) => {
    const navigate = useNavigate();
    const rvsDashboardQuery = useGrowersDashboard({
        node: userNodeId,
        nodeType: 'rv',
    });

    return (
        <DashboardCard
            title={_('Representantes de ventas')}
            isLoading={rvsDashboardQuery.isLoading}
            buttonProps={{
                children: _('Ver RVs'),
                onClick: () => {
                    navigate(reverse('RVs.list'));
                },
                color: 'secondary',
            }}
            number={rvsDashboardQuery.data?.count}
        />
    );
};

export default RVsDashboardCard;
